export const TAG_TYPES = [
	'PersonBookings',
	'Bookings',
	'SecurityBookings',
	'Objects',
	'BookingObjectTypes',
	'PassTypes',
	'Persons',
	'AllObjects',
	'AvailableObjects',
	'RootObjects',
	'Passes',
	'Restrictions',
];
